// extracted by mini-css-extract-plugin
export default {"pagination-select":"ResultsPerPage_pagination-select__KYHsm"};